var _defs, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack541({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:0.5px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.79,8.47a1.64,1.64,0,0,1,.34-1.14A1.16,1.16,0,0,1,6,7,1.19,1.19,0,0,1,7,7.33a1.6,1.6,0,0,1,.34,1.14A1.64,1.64,0,0,1,7,9.61a1.16,1.16,0,0,1-.92.37,1.18,1.18,0,0,1-.93-.37A1.6,1.6,0,0,1,4.79,8.47Zm.86,0a1.45,1.45,0,0,0,.13.75A.28.28,0,0,0,6,9.35a.31.31,0,0,0,.28-.14,1.59,1.59,0,0,0,.12-.75,1.51,1.51,0,0,0-.12-.74A.32.32,0,0,0,6,7.57a.3.3,0,0,0-.26.14A1.45,1.45,0,0,0,5.65,8.46ZM6.88,13H6.07l3-6h.79Zm1.77-1.5A1.65,1.65,0,0,1,9,10.36,1.2,1.2,0,0,1,9.92,10a1.16,1.16,0,0,1,.92.37,1.6,1.6,0,0,1,.34,1.14,1.64,1.64,0,0,1-.34,1.14,1.16,1.16,0,0,1-.91.37A1.21,1.21,0,0,1,9,12.64,1.69,1.69,0,0,1,8.65,11.5Zm.86,0a1.42,1.42,0,0,0,.13.75.33.33,0,0,0,.54,0,1.5,1.5,0,0,0,.13-.75,1.45,1.45,0,0,0-.13-.75.33.33,0,0,0-.54,0A1.45,1.45,0,0,0,9.51,11.49Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack541);
export default __webpack_public_path__ + "static/media/Symbolpack_5_41.8406706dc97085cdbb83771e0ad35da0.svg";
export { ForwardRef as ReactComponent };